/**
 * @generated SignedSource<<5c7241cd34c074fc014081eff6bea2bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateAddFlightDialog_package$data = {
  readonly defaultArrivalAirport: {
    readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_defaultArrivalAirport">;
  } | null;
  readonly defaultDepartureAirport: {
    readonly " $fragmentSpreads": FragmentRefs<"FlightSearchForm_defaultDepartureAirport">;
  } | null;
  readonly " $fragmentType": "PackageDateAddFlightDialog_package";
};
export type PackageDateAddFlightDialog_package$key = {
  readonly " $data"?: PackageDateAddFlightDialog_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateAddFlightDialog_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Airport",
      "kind": "LinkedField",
      "name": "defaultDepartureAirport",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightSearchForm_defaultDepartureAirport"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Airport",
      "kind": "LinkedField",
      "name": "defaultArrivalAirport",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FlightSearchForm_defaultArrivalAirport"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Package",
  "abstractKey": null
};

(node as any).hash = "10485adc6f3249c7434c63e70b0a8b7d";

export default node;
